import React, { useState } from 'react';

const Faq = () => {
    const [show,setShow] = useState(true);
    const database = [
        {
            title:"Non consectetur a erat nam at lectus urna duis?",
            para:"Feugiat pretium nibh ipsum consequat. Tempus iaculis urna id volutpat lacus laoreet non curabitur gravida. Venenatis lectus magna fringilla urna porttitor rhoncus dolor purus non."
        },
        {
            title:"Feugiat scelerisque varius morbi enim nunc faucibus a pellentesque?",
            para:"Dolor sit amet consectetur adipiscing elit pellentesque habitant morbi. Id interdum velit laoreet id donec ultrices. Fringilla phasellus faucibus scelerisque eleifend donec pretium. Est pellentesque elit ullamcorper dignissim. Mauris ultrices eros in cursus turpis massa tincidunt dui."
        },
        {
            title:"Dolor sit amet consectetur adipiscing elit pellentesque habitant morbi?",
            para:"Eleifend mi in nulla posuere sollicitudin aliquam ultrices sagittis orci. Faucibus pulvinar elementum integer enim. Sem nulla pharetra diam sit amet nisl suscipit. Rutrum tellus pellentesque eu tincidunt. Lectus urna duis convallis convallis tellus. Urna molestie at elementum eu facilisis sed odio morbi quis"
        },
        {
            title:"Ac odio tempor orci dapibus. Aliquam eleifend mi in nulla?",
            para:"Dolor sit amet consectetur adipiscing elit pellentesque habitant morbi. Id interdum velit laoreet id donec ultrices. Fringilla phasellus faucibus scelerisque eleifend donec pretium. Est pellentesque elit ullamcorper dignissim. Mauris ultrices eros in cursus turpis massa tincidunt dui."
        },
        {
            title:"Tempus quam pellentesque nec nam aliquam sem et tortor consequat?",
            para:"Molestie a iaculis at erat pellentesque adipiscing commodo. Dignissim suspendisse in est ante in. Nunc vel risus commodo viverra maecenas accumsan. Sit amet nisl suscipit adipiscing bibendum est. Purus gravida quis blandit turpis cursus in"
        },
        {
            title:"Tortor vitae purus faucibus ornare. Varius vel pharetra vel turpis nunc eget lorem dolor?",
            para:"Laoreet sit amet cursus sit amet dictum sit amet justo. Mauris vitae ultricies leo integer malesuada nunc vel. Tincidunt eget nullam non nisi est sit amet. Turpis nunc eget lorem dolor sed. Ut venenatis tellus in metus vulputate eu scelerisque. Pellentesque diam volutpat commodo sed egestas egestas fringilla phasellus faucibus. Nibh tellus molestie nunc non blandit massa enim nec.n"
        }
    ]
  return (
    <>
      <div className='mainFaq'>
      <div className='serviceText'>
            <h4>F.A.Q</h4>
            <h2>Frequently Asked Questions</h2>
            <div></div>
        </div>
        <div className='faqdata'>
            {
                database.map(({title,para},index)=>{
                    return (
                        <div className='faqInfo' key={index}>
                <h2 onClick={()=>setShow(!show)} >{title}</h2>
                {
                    show ? <p>{para}</p>:<p></p>
                }
                <hr style={{"marginTop":"1rem"}}/>
            </div>
                    )
                })
            }
        </div>
      </div>
    </>
  )
}

export default Faq
